import {
  CapaQuotationDetailedServiceType,
  CapaQuotationServiceType,
  RegisterRfqInput
} from '@generated/graphql';

export enum PcbRequestStageEnum {
  PROCESS_SELECT = 'PROCESS_SELECT',
  PCB = 'PCB', // A타입, 1페이지 FORM
  DESIGN = 'DESIGN', // B타입, 설계
  FABRICATION = 'FABRICATION', // B타입, 제작
  ASSEMBLY = 'ASSEMBLY', // B타입, 조립
  PROJECT_COMMON = 'PROJECT_COMMON', // B타입, 프로젝트 공통
  CONSULTING_START_METHOD = 'CONSULTING_START_METHOD', // B타입, 상담 시작 방식
  PREVIEW = 'PREVIEW', // 미리보기
  COMPLETE = 'COMPLETE' // 완료
}

export enum DesignRequestStageEnum {
  PROCESS_SELECT = 'PROCESS_SELECT',
  DESIGN = 'DESIGN', // A타입, 1페이지 FORM
  REFERENCE = 'REFERENCE', // B타입, 참고파일 첨부 및 상세 요청
  PROTOTYPING = 'PROTOTYPING', // B타입, 시제품 제작 여부
  PROJECT_COMMON = 'PROJECT_COMMON', // B타입, 프로젝트 공통
  CONSULTING_START_METHOD = 'CONSULTING_START_METHOD', // B타입, 상담 시작 방식
  PREVIEW = 'PREVIEW', // 미리보기
  COMPLETE = 'COMPLETE' // 완료
}

export interface RequestQueryString {
  serviceType?: CapaQuotationServiceType;
  detailedServiceType?: CapaQuotationDetailedServiceType;
  process?: string;
  stage?: PcbRequestStageEnum | DesignRequestStageEnum;
  reWrite?: string;
  rfqId?: string;
}
export interface ConsultingStartMethodForm
  extends Pick<RegisterRfqInput, 'consultingStartMethod'> {}
